"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgTool01 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 8a7 7 0 0 1 9.353-6.595 1 1 0 0 1 .37 1.65L16.48 5.321c-.318.321-.477.482-.552.66a1 1 0 0 0 .002.781c.076.178.236.338.556.657.32.32.481.481.66.557a1 1 0 0 0 .781 0c.178-.075.339-.235.66-.554l2.304-2.293a1 1 0 0 1 1.64.346 7 7 0 0 1-8.193 9.325 15.587 15.587 0 0 0-.583-.134 9.122 9.122 0 0 0-.3.292l-6.248 6.248a3.121 3.121 0 1 1-4.414-4.414l6.248-6.248c.144-.144.225-.225.28-.287.016-.018.007-.037.002-.066a15.488 15.488 0 0 0-.124-.53A7.014 7.014 0 0 1 9 8Z", fill: "currentColor" }) }))); };
exports.default = SvgTool01;
